<template>
  <modal name="make-auction" class="make-auction" width="95%" height="auto" :scrollable="true">
    <LoadingSpinner v-if="loader" />
    <div v-else class="make-auction-modal">
      <!-- Close Button -->
      <button class="btn-close" @click="hide('make-auction')">
        <span class="mdi mdi-alpha-x-circle"></span>
      </button>

      <!-- Header -->
      <h3 class="modal-title">{{ $t("action.placeBid") }}</h3>

      <!-- Product Info -->
      <div class="product-info">
        <img :src="productImage" alt="product" class="product-img" />
        <div>
          <h4 class="product-name">{{ product.name }}</h4>
          <p class="product-price">
            {{ $t("ecommerce.product.currentBid") }}: {{ currentBid }} DA<br>
            {{ $t("ecommerce.product.minimumBid") }}: {{ minimumBid }} DA
          </p>
        </div>
      </div>

      <!-- Quick Bid Options -->
      <div class="bid-options">
        <div v-for="(option, index) in bidOptions" :key="index" class="bid-option"
          :class="{ selected: selectedOption === index }" @click="selectOption(index)">
          <strong>{{ option }} DA</strong>
          <small>{{ $t('ecommerce.quickOffer') }}</small>
        </div>
        <!-- Custom Option -->
        <!-- <div class="bid-option" :class="{ selected: selectedOption === 'custom' }" @click="selectOption('custom')">
          <strong>Autre</strong>
          <small>Proposez votre enchère</small>
        </div> -->
      </div>

      <!-- Custom Input -->
      <!-- <div class="custom-input">
        <input v-model.number="customBid" type="number" :min="minimumBid" step="1" class="form-control"
          :placeholder="$t('ecommerce.product.enterBid')" />
      </div> -->

      <!-- AutoBid Input -->
      <div class="custom-input" style="margin-top: 10px;">
        <label><strong>Autobid Maximum</strong></label>
        <input v-model.number="autoBidMax" @click="selectOption('custom')" type="number" :min="minimumBid" class="form-control"
          placeholder="Montant maximum que vous pouvez payer (AutoBid)" />
      </div>

      <!-- Confirm Button -->
      <button class="btn-propose" @click="sendBid">
        {{ displayBid ? `${$t('action.confirm')} ${displayBid}` : 'Enchérir' }}
      </button>
    </div>
  </modal>
</template>

<script>
import config from "@/config";
import Helper from '@/services/helper';
import Vue from 'vue';
import LoadingSpinner from "@/components/templates/LoadingSpinner.vue";

// Register currency filter locally if not globally available
if (!Vue.options.filters||!Vue.options.filters.currency) {
  Vue.filter('currency', function (value, symbol='', decimals=0, options={}) {
    if (typeof value!=="number") value=parseFloat(value);
    if (isNaN(value)) return '';
    let formatted=value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    if (options.symbolOnLeft) {
      return symbol+formatted;
    } else {
      return formatted+symbol;
    }
  });
}

export default {
  props: {
    product: Object,
    img: String,
  },
  components: {
    LoadingSpinner
  },
  data() {
    return {
      selectedOption: null,
      customBid: "",
      autoBidMax: "",
      loader: false,
      bidOptions: [],
      storageUrl: config.storageUrl,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    currentBid() {
      if (!this.product) return 0;
      return this.product.bids&&this.product.bids.length>0
        ? parseFloat(this.product.bids[0].price)
        :parseFloat(this.product.starting_price)||0;
    },
    minimumBid() {
      const price=this.currentBid;
      if (price<100) return price+5;
      if (price<1000) return price+10;
      if (price<2000) return price+50;
      if (price<10000) return price+100;
      return price+Math.ceil(price*0.05);
    },
    productImage() {
      if (this.img) return this.img;

      if (!this.product||!this.product.pictures) return '';

      const picture=Array.isArray(this.product.pictures)
        ? this.product.pictures[0]
        :this.product.pictures;

      return this.storageUrl+picture;
    },
    displayBid() {
      if (this.selectedOption===null) return this.minimumBid;
      if (this.selectedOption==="custom")
        return this.autoBidMax? parseFloat(this.autoBidMax):this.minimumBid;
      return this.bidOptions[this.selectedOption];
    },
  },
  watch: {
    product: {
      handler(newProduct) {
        if (newProduct) {
          this.resetModalState();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.updateBidOptions();
  },
  methods: {
    resetModalState() {
      // Reset all state when product changes
      this.selectedOption=null;
      this.customBid="";
      this.autoBidMax="";
      this.updateBidOptions();
    },
    hide(modal) {
      this.$modal.hide(modal);
    },
    selectOption(index) {
      this.selectedOption=index;
      if (index!=='custom') {
        this.autoBidMax ='';
        this.customBid=Helper.roundToHundreds(this.bidOptions[index]);
      }
    },
    updateBidOptions() {
      const step=this.minimumBid-this.currentBid;

      // Raw options before rounding
      const opt1=this.minimumBid;
      const opt2=this.minimumBid+step;
      const opt3=this.minimumBid+2*step;

      // Apply rounding
      this.bidOptions=[
        Helper.roundToHundreds(opt1),
        Helper.roundToHundreds(opt2),
        Helper.roundToHundreds(opt3),
      ];
    }
    ,
    onBidSentFromModal(productId) {
      console.log(productId);
      this.getUserBids();
      this.$modal.hide('make-auction');
    },
    sendBid() {
      if (!this.isLoggedIn) {
        this.$router.push({
          name: "login"
        })
        return;
      }
      const bidPrice=parseFloat(this.displayBid);
      console.log(bidPrice);
      console.log(this.currentBid);
      console.log(this.minimumBid);

      if (!bidPrice||bidPrice<=this.currentBid||bidPrice<this.minimumBid) {
        this.$notify({
          group: "error",
          title: "Erreur",
          text: "Veuillez mettre une enchère valide !",
          type: "error",
        });
        return;
      }

      const data={
        product_id: this.product.id,
        quantity: 1,
        price: bidPrice,
        autobid_max: this.autoBidMax? parseFloat(this.autoBidMax):null, // NEW
        text: `Je propose ${bidPrice.toFixed(2)} DA pour ce produit`,
      };

      this.loader=true;
      this.$axios({
        url: "bids/create",
        method: "POST",
        data,
      })
        .then((res) => {
          this.loader=false;

          this.hide("make-auction");
          if (res.data&&res.data.success) {
            if (!this.product.bids) {
              this.product.bids=[];
            }
            this.product.bids.unshift({ price: bidPrice });

            this.resetModalState();

            this.$notify({
              group: "success",
              title: "Bravo !",
              text: "Votre enchère a été envoyée avec succès !",
              type: "success",
            });
            this.$emit("bid-sent", this.product.id);
          } else {
            this.$notify({
              group: "error",
              title: "Erreur",
              text:
                (res.data&&res.data.message)||
                "Une erreur s'est produite lors de l'envoi de l'enchère.",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.loader=false;
          if (err.response&&err.response.status===403) {
            this.show("login-user");
          } else {
            this.$notify({
              group: "error",
              title: "Erreur",
              text:
                (err.response&&this.$t(err.response.data.message))||
                "Une erreur s'est produite.",
              type: "error",
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.make-auction-modal {
  padding: 1.5rem;
  max-width: 600px;
  margin: auto;
  background: white;
  border-radius: 16px;
  font-family: "Inter", sans-serif;
  color: var(--color-3);
  position: relative;
  max-height: 90vh; /* Add max height */
  overflow-y: auto; /* Enable vertical scrolling */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

.modal-title {
  text-align: center;
  font-weight: 600;
  color: var(--color-3);
  margin-bottom: 1rem;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: #f8f8f8;
  padding: 0.8rem;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.product-img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}

.product-name {
  font-size: 1rem;
  margin: 0;
  color: var(--color-2);
}

.product-price {
  font-size: 0.9rem;
  color: var(--color-7);
}

.bid-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 8px;
  margin-bottom: 1rem;
}

.bid-option {
  text-align: center;
  border: 1px solid #d0dada;
  border-radius: 8px;
  padding: 10px 5px;
  cursor: pointer;
  transition: 0.2s;
}

.bid-option:hover {
  border-color: var(--color-nz);
}

.bid-option.selected {
  border: 2px solid var(--color-nz);
  background: #f1fdfd;
}

.bid-option strong {
  display: block;
  color: var(--color-1);
  font-size: 1rem;
}

.bid-option small {
  color: var(--color-6);
  font-size: 0.8rem;
}

.custom-input {
  text-align: center;
  margin-bottom: 1rem;
}

.custom-input .form-control {
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--color-c);
  padding: 8px;
}

.custom-message textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--color-c);
  padding: 8px;
  margin-bottom: 1rem;
  resize: none;
}

@media (max-width: 768px) {
  .make-auction-modal {
    padding: 1rem;
    max-width: 90%;
    max-height: 85vh; /* Slightly lower on tablets */
  }

  .product-info {
    flex-direction: column;
    text-align: center;
  }

  .product-img {
    width: 80px;
    height: 80px;
  }

  .bid-options {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 480px) {
  .make-auction-modal {
    padding: 0.8rem;
    max-height: 80vh; /* Even more restricted on small phones */
    overflow-y: auto; /* Ensure scrolling is enabled */
  }

  .modal-title {
    font-size: 1.1rem;
  }

  .bid-options {
    grid-template-columns: 1fr;
  }

  .bid-option strong {
    font-size: 0.95rem;
  }


}
</style>
